/* eslint-disable no-param-reassign */
import { generateTimeRemainingText } from "common/utils/ui/generate-time-remaining";

const TIMER_UPDATE_INTERVAL = 60_000;

// Using a module-level variable ensures that timers are shared across every
// consumer of `createTimerManager`, even if they invoke the factory multiple
// times (e.g. every time a new `DeliveryDateClass` is instantiated).
let singleton;

const createTimerManager = () => {
  if (singleton) return singleton;

  const timers = new Set();

  const clearTimers = () => {
    timers.forEach(timer => clearTimeout(timer));
    timers.clear();
  };

  const makeTimer = ($cutoffNode, cutoff) => {
    const updateTimer = () => {
      const curTime = Date.now();
      const diff = Math.floor((cutoff - curTime) / 1000);

      $cutoffNode.textContent = generateTimeRemainingText(cutoff);
      $cutoffNode.dataset.timeLeftInMinutes = Math.floor(diff / 60);

      const timerId = setTimeout(updateTimer, TIMER_UPDATE_INTERVAL);
      timers.add(timerId);
    };

    updateTimer();
  };

  singleton = { makeTimer, clearTimers };
  return singleton;
};

export default createTimerManager;
